<template>
    <div class="py-9 flex flex-col">
        <h3 class="text-lg font-black tracking-wider px-9">{{ heading }}</h3>
        <div class="max-h-[350px] overflow-y-auto px-9 space-y-1 mt-3">
            <div
                class="flex gap-3 items-center"
                v-for="(option, key) in options"
                :key="key"
            >
                <input
                    type="checkbox"
                    :ref="'checkbox-' + option.val"
                    :id="index + key"
                    :value="true"
                    :checked="isChecked(option)"
                    :disabled="optionDisabled(option)"
                    @click="toggleStaticFilter(option)"
                    class="peer cursor-pointer disabled:cursor-auto"
                />
                <label :for="index + key" class="text-black peer-disabled:text-xp-medium-grey text-lg font-normal">
                    {{ option.val + (option.unit || '') }}
                </label>
            </div>
        </div>
        <div class="px-9 pt-7 mt-auto flex justify-end">
            <button
                type="button"
                class="text-sm tracking-[2.51px] font-black uppercase underline underline-offset-4 decoration-2 decoration-xp-lilac hover:decoration-xp-electron-green"
                v-on:click="filterReset"
            >
                Reset
            </button>
        </div>
    </div>
</template>

<script>
import isEqual from 'lodash.isequal'
import Filter from '../../../../../mixins/filters/Filter'

export default {
    name: 'ProductStaticFilter',
    mixins: [Filter],
    methods: {
        isChecked(option) {
            return isEqual(this.activeFilters?.vals?.[0], option)
        },
        toggleStaticFilter(option) {
            const selected = this.activeFilters?.vals?.[0].val === option.val

            this.uncheckFilters()
            this.filterReset()

            !selected
            && this.setFilters(option)
        },
        setFilters(option) {
          this.toggleFilter(option)
          this.$refs['checkbox-' + option.val][0].checked = true
        },
        uncheckFilters() {
            this.options.forEach(option => {
                this.$refs['checkbox-' + option.val][0].checked = false
            })

        }
    },
}
</script>
